import { usePerformanceChart, useTheme } from "@hooks";

export const DashedLineBackground = () => {
  const { theme } = useTheme();

  const { width } = usePerformanceChart();

  const strokeColor = theme.chart.performance.stroke;

  return (
    <>
      <line
        x1="0"
        y1="15%"
        x2={width}
        y2="15%"
        stroke={strokeColor}
        strokeOpacity="0.12"
        strokeDasharray="4 4"
      />
      <line
        x1="0"
        y1="50%"
        x2={width}
        y2="50%"
        stroke={strokeColor}
        strokeOpacity="0.12"
        strokeDasharray="4 4"
      />
      <line
        x1="0"
        y1="85%"
        x2={width}
        y2="85%"
        stroke={strokeColor}
        strokeOpacity="0.12"
        strokeDasharray="4 4"
      />
    </>
  );
};
